module.exports = "<span class=\"aTitle\">{{title}}</span><br />\n<ul>\n\t<li>New York D.A.R. Outstanding Volunteer for Veterans Service Award, North Eastern Division </li>\n\t<li>New York D.A.R. Project Patriot Committee Appreciation Award </li>\n\t<li>An Honored Member of Cambridge Who&#39;s Who 2006/2007 Edition </li>\n\t<li>Registered Executive &amp; Professionals </li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/awards.component.html
// module id = 157
// module chunks = 1